import { Box, Modal } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { RxCross1 } from "react-icons/rx";
import {
  changeInboxWarehousePaymentStatus,
  changeWarehousePaymentStatus,
} from "../../../../services/centralWarehouseApi";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalChangePaymentStatus = ({
  reqChangePayment,
  setReqChangePayment,
  refetch,
  type,
  isInbox,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setReqChangePayment(null);
  };

  const { mutate: mutateStatusPay, isLoading } = useMutation({
    mutationFn: changeWarehousePaymentStatus,
    onSuccess: () => {
      refetch();
      handleClose();
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  const { mutate: mutateStatusPayInbox, isLoading: isLoadingInbox } =
    useMutation({
      mutationFn: changeInboxWarehousePaymentStatus,
      onSuccess: () => {
        refetch();
        handleClose();
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  return (
    <Modal open={reqChangePayment} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          maxWidth: "75%",
          overflowY: "auto",
          overflowX: "wrap",
          maxHeight: "60vh",
          padding: 0,
        }}
        className="text-left text-base w-3/4 lg:w-1/3"
      >
        <div className="flex justify-between items-center px-8 py-4 text-[12px]">
          <p className="font-bold text-lg ">Ubah Status Pembayaran</p>
          <RxCross1
            className="cursor-pointer hover:text-red-500"
            onClick={handleClose}
          />
        </div>

        <div className="px-8 mb-4">
          <p>
            Apakah anda yakin ingin mengubah status pembayaran{" "}
            {type === 1 ? "alokasi" : "transfer"} ini menjadi{" "}
            {reqChangePayment && reqChangePayment.is_paid
              ? "lunas"
              : "belum dibayar"}
            ?
          </p>
          <p className="text-red-500 mt-2">{errorMessage}</p>
        </div>

        <div className="px-8 mb-4 flex gap-2 w-full">
          <button
            type="button"
            className="w-full rounded-md p-2 border-2 hover:bg-gray-100 disabled:bg-gray-300"
            onClick={handleClose}
            disabled={isLoading || isLoadingInbox}
          >
            Batal
          </button>
          <button
            type="button"
            className="w-full rounded-md p-2 bg-blue-500 text-white hover:bg-gray-300 disabled:bg-gray-300"
            onClick={() => {
              isInbox
                ? mutateStatusPayInbox(reqChangePayment)
                : mutateStatusPay(reqChangePayment);
            }}
            disabled={isLoading || isLoadingInbox}
          >
            Ubah
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalChangePaymentStatus;
